var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css } from "styled-components";
import ErrorLabel from "./ErrorLabel";
import _ from "lodash";
const StyledInputItem = styled.div `
  position: relative;
  display: block;

  ${props => props.variant === "money-input" &&
    css `
      &:before {
        position: absolute;
        display: block;
        content: "€";
        top: 30px;
        left: 10px;
        color: ${props => props.theme.tertiary};
      }
    `};
`;
const StyledInput = styled.input `
  transition: border-color 0.2s ease-in-out;
  padding: 30px 20px 16px 10px;
  background-color: transparent;
  border: 1px solid #b2babf;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  font-size: 16px;
  line-height: 1.2rem;
  color: #69696f;
  border-radius: 4px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &::-webkit-input-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &::-moz-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &:-ms-input-placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &::placeholder {
    opacity: 1;
    transition: all 0.2s;
  }

  &:placeholder-shown:not(:focus)::-webkit-input-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus)::-moz-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus):-ms-input-placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus)::placeholder {
    opacity: 0;
  }

  &:placeholder-shown:not(:focus) + * {
    font-size: 16px;
    top: 50%;
    transform: translateY(-50%);
    color: #69696f;
    font-weight: 400;
  }

  &:disabled {
    background-color: #eeeeee;
    cursor: default;

    + label {
      opacity: 0.5;
    }
  }
`;
const IconWrapper = styled.div `
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
`;
const StyledLabel = styled.label `
  position: absolute;
  top: 7px;
  left: 10px;
  pointer-events: none;
  color: ${props => props.theme.tertiary};
  font-weight: 600;
  font-family: ${props => props.theme.fontBase};
  transition: all 0.2s;
  font-size: 85%;
  opacity: 1;
  cursor: text;

  @media only screen and (min-width: 540px) {
    left: 10px;
  }
`;
const StyledOuterWrapper = styled.div `
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const InputItem = (_a) => {
    var { id, className, icon, label, error, variant } = _a, props = __rest(_a, ["id", "className", "icon", "label", "error", "variant"]);
    return (React.createElement(StyledOuterWrapper, { className: className },
        React.createElement(StyledInputItem, { className: className, variant: variant },
            React.createElement(StyledInput, Object.assign({ id: id }, props)),
            React.createElement(StyledLabel, { htmlFor: id }, label),
            React.createElement(IconWrapper, null, icon),
            !!error && React.createElement(ErrorLabel, null, _.capitalize(error)))));
};
export default InputItem;
